import { GoogleMapMarker, GoogleMapMarkerType, GoogleMapPopup } from '@lib/geo/google/map';
import { THEME } from '@lib/ui/theme';

import { SnPlate } from '../../api';

export class SnPlateMarker extends GoogleMapMarker {
  public infoWindow: GoogleMapPopup;

  constructor(public readonly plate: SnPlate) {
    super({
      id: `plate-${plate.id}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: {
        lng: plate.geometry.coordinates[0],
        lat: plate.geometry.coordinates[1],
      },
      title: plate.plate,
      style: {
        scale: 1.5,
        strokeOpacity: 1,
        fillOpacity: 1,
        fillColor: THEME.success,
      },
      icon: {
        fontSet: 'fa',
        fontIcon: 'fa-car',
      },
    });
  }
}
